module.exports = __webpack_public_path__ + "static/media/point-of-interest-icon.fd31e235.svg";